import { render, staticRenderFns } from "./x-tag.vue?vue&type=template&id=0077c03c&scoped=true&"
import script from "./x-tag.vue?vue&type=script&lang=js&"
export * from "./x-tag.vue?vue&type=script&lang=js&"
import style0 from "./x-tag.vue?vue&type=style&index=0&id=0077c03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077c03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0077c03c', component.options)
    } else {
      api.reload('0077c03c', component.options)
    }
    module.hot.accept("./x-tag.vue?vue&type=template&id=0077c03c&scoped=true&", function () {
      api.rerender('0077c03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-tag.vue"
export default component.exports